var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46449 2.3335H7.53489C7.05849 2.3335 6.82029 2.3335 6.60667 2.40816C6.47621 2.45376 6.35364 2.51936 6.24334 2.60261C6.06271 2.73894 5.93059 2.93712 5.66634 3.3335C5.53101 3.53651 5.33151 3.83574 5.252 3.9193C5.05498 4.12634 4.79664 4.2646 4.51508 4.31369C4.40145 4.3335 4.27945 4.3335 4.03547 4.3335C3.38208 4.3335 3.05539 4.3335 2.78827 4.40911C2.12005 4.59827 1.59778 5.12053 1.40862 5.78876C1.33301 6.05588 1.33301 6.38257 1.33301 7.03596V9.66683C1.33301 11.5524 1.33301 12.4952 1.91879 13.081C2.50458 13.6668 3.44739 13.6668 5.33301 13.6668H10.6664C12.552 13.6668 13.4948 13.6668 14.0806 13.081C14.6664 12.4952 14.6664 11.5524 14.6664 9.66683V7.03596C14.6664 6.38257 14.6664 6.05588 14.5908 5.78876C14.4016 5.12053 13.8793 4.59827 13.2111 4.40911C12.944 4.3335 12.6173 4.3335 11.9639 4.3335C11.7199 4.3335 11.5979 4.3335 11.4843 4.31369C11.2027 4.2646 10.9444 4.12634 10.7474 3.9193C10.6678 3.83574 10.4684 3.5365 10.333 3.3335C10.0688 2.93712 9.93662 2.73894 9.75602 2.60261C9.64569 2.51936 9.52315 2.45376 9.39269 2.40816C9.17909 2.3335 8.94089 2.3335 8.46449 2.3335Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6664 8.66667C10.6664 10.1394 9.47242 11.3333 7.99969 11.3333C6.52691 11.3333 5.33301 10.1394 5.33301 8.66667C5.33301 7.19393 6.52691 6 7.99969 6C9.47242 6 10.6664 7.19393 10.6664 8.66667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 6.3335V6.34016",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIc);
export default __webpack_public_path__ + "static/media/camera_ic.bc7dd4656cdc65cb4bc0e408bc9f9b7f.svg";
export { ForwardRef as ReactComponent };